import { combineReducers } from 'redux';
import { offsetEmission } from "./offset-emmision/offsetEmission.reducer"

export const greenProject = combineReducers({
    offsetEmission,
});
